import { useEffect, useState } from 'react'
import { Container, Header, Loader, Dimmer } from 'semantic-ui-react'

import BookkeepingReportTable from './BookkeepingReportTable'
import { fetchAllUsersBookkeepingReports } from '../../actions/admin/bookkeepingReportActions'
import { fetchAllUsersIfNeeded } from '../../actions/admin/adminAllUsersActions'
import { getIncompleteReports } from '../../selectors/reportSelectors'
import { useReselector } from '../../utils/sharedHooks'
import { useAppDispatch } from '../../utils/typeHelpers'

const IncompleteBookkeepingReportsPanel = () => {
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(true)
  const reports = useReselector(getIncompleteReports)

  useEffect(() => {
    const fetch = async () => {
      await Promise.all([
        dispatch(fetchAllUsersIfNeeded()),
        dispatch(fetchAllUsersBookkeepingReports()),
      ])

      setLoading(false)
    }

    fetch()
  }, [dispatch])

  return (
    <Container id="allReportsPanel">
      <Header as="h3">Incomplete Bookkeeping Reports</Header>
      <br />
      {loading ? (
        <Dimmer active inverted>
          <Loader inverted>Loading all reports</Loader>
        </Dimmer>
      ) : (
        <BookkeepingReportTable reports={reports} />
      )}
    </Container>
  )
}

export default IncompleteBookkeepingReportsPanel
